import type { SVGProps } from 'react'
const SvgHowToReg = (props: SVGProps<SVGSVGElement>) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="how-to-reg_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#how-to-reg_svg__a)">
      <path d="M1.33 15.229v-2.262q0-.66.345-1.239t.94-.878a12 12 0 0 1 2.19-.832 10 10 0 0 1 2.677-.344q.563 0 1.166.067.604.068 1.11.18l-1.5 1.497a2 2 0 0 0-.382-.038h-.394q-1.313 0-2.373.319-1.059.318-1.698.667a.75.75 0 0 0-.272.255.67.67 0 0 0-.103.369v.532h4.57l1.707 1.707zm10.454.201-2.637-2.637 1.099-1.095 1.537 1.538 3.788-3.788 1.1 1.095zM7.482 8.924q-1.305 0-2.229-.924A3.04 3.04 0 0 1 4.33 5.77q0-1.305.923-2.226a3.04 3.04 0 0 1 2.229-.922q1.305 0 2.229.922a3.03 3.03 0 0 1 .923 2.226q0 1.305-.923 2.229a3.04 3.04 0 0 1-2.229.924m0-1.706q.597 0 1.021-.425.425-.425.425-1.022 0-.596-.425-1.019a1.4 1.4 0 0 0-1.02-.422q-.597 0-1.022.423a1.39 1.39 0 0 0-.425 1.018q0 .596.425 1.022.425.425 1.02.425" />
    </g>
  </svg>
)
export default SvgHowToReg
